/* eslint-disable confluence-feature-gating/inline-expVal-params */
import { expValEquals } from '@confluence/feature-experiments';

const COHORT_PARAM = 'cohort';

/**
 * Result of the eligibility check
 */
export interface OmnibarEligibilityResult {
	showReactions: boolean;
	showComments: boolean;
}

/**
 * Hook to determine OmniBar eligibility and configuration based on Statsig experiments.
 *
 * Checks two experiments in parallel (user will be in exactly one based on Statsig targeting):
 * - `cc_engagement_omnibar` for Non-SMB + New users
 * - `cc_engagement_omnibar_smb` for SMB + Existing users
 *
 * @param skip - When true, skips the experiment check and returns showReactions/showComments as false
 * @returns OmnibarEligibilityResult with eligibility status and configuration
 */
export const useOmnibarEligibility = (skip: boolean = false): OmnibarEligibilityResult => {
	if (skip) {
		return {
			showReactions: false,
			showComments: false,
		};
	}

	const showReactions =
		expValEquals('cc_engagement_omnibar_aa', COHORT_PARAM, 'variant_reactions') ||
		expValEquals('cc_engagement_omnibar_aa', COHORT_PARAM, 'variant_reactions_comments') ||
		expValEquals('cc_engagement_omnibar_aa', COHORT_PARAM, 'variant_reactions') ||
		expValEquals('cc_engagement_omnibar_aa', COHORT_PARAM, 'variant_reactions_comments');

	const showComments =
		expValEquals('cc_engagement_omnibar_aa', COHORT_PARAM, 'variant_reactions_comments') ||
		expValEquals('cc_engagement_omnibar_aa', COHORT_PARAM, 'variant_reactions_comments');

	return {
		showReactions,
		showComments,
	};
};
